(() => {
  const initializeGallery = (gallery) => {
    if (gallery.dataset.galleryReady === 'true') return;

    const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
    const dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
    const previous = gallery.querySelector('[data-gallery-previous]');
    const next = gallery.querySelector('[data-gallery-next]');
    let activeIndex = Math.min(Number(gallery.dataset.initialIndex) || 0, slides.length - 1);

    const show = (index) => {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => slide.classList.toggle('is-active', slideIndex === activeIndex));
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === activeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    };

    previous?.addEventListener('click', () => show(activeIndex - 1));
    next?.addEventListener('click', () => show(activeIndex + 1));
    dots.forEach((dot, index) => dot.addEventListener('click', () => show(index)));
    show(activeIndex);
    gallery.dataset.galleryReady = 'true';
  };

  const initialize = () => document.querySelectorAll('[data-v1-product-gallery]').forEach(initializeGallery);

  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
  if (document.readyState !== 'loading') initialize();
})();
